// extracted by mini-css-extract-plugin
export default {"generationMainContainer":"ContractGenerator_generationMainContainer__GoJ2k","mainContent":"ContractGenerator_mainContent__GJY3J","inputItem":"ContractGenerator_inputItem__M090t"};